'use client'
import { usePathname } from 'next/navigation'
import Link from 'next/link'

// Icons
import { Icons } from '@/components/shared/icons'

// Types
import type { Locale } from '@/i18n-config'

export default function LocaleSwitcher() {
  const pathname = usePathname()

  // Extract current locale from pathname
  const currentLocale = (pathname.split('/')[1] as Locale) || 'tr'
  const isEnglish = currentLocale === 'en'

  const redirectedPathname = (locale: Locale) => {
    if (!pathname) return `/${locale}`
    const segments = pathname.split('/')

    // If pathname is just '/' or starts with locale, handle accordingly
    if (pathname === '/' || segments[1] === 'tr' || segments[1] === 'en') {
      segments[1] = locale
    } else {
      // Insert locale as first segment
      segments.splice(1, 0, locale)
    }

    // If pathname includes 'projects', handle locale suffix
    if (pathname.includes('projects/')) {
      // Check if the last segment is a slug, if so, handle locale suffix
      const lastSegment = segments[segments.length - 1]
      if (!lastSegment.includes('.')) {
        if (locale === 'en') {
          // Add "-en" if not already present
          if (!lastSegment.endsWith('-en')) {
            segments[segments.length - 1] = lastSegment + '-en'
          }
        } else if (locale === 'tr') {
          // Remove "-en" if present
          if (lastSegment.endsWith('-en')) {
            segments[segments.length - 1] = lastSegment.replace('-en', '')
          }
        }
      }
    }

    return segments.join('/') || '/'
  }

  return (
    <div>
      {!isEnglish ? (
        <Link
          href={redirectedPathname('en')}
          className="flex items-center gap-2 rounded-lg border border-muted-foreground px-1"
        >
          <Icons.uk className="size-8" />
          <span className="text-sm">EN</span>
          <span className="sr-only">Change language to english</span>
        </Link>
      ) : (
        <Link
          href={redirectedPathname('tr')}
          className="flex items-center gap-2 rounded-lg border border-muted-foreground px-1"
        >
          <Icons.turkey className="size-8" />
          <span className="text-sm">TR</span>
          <span className="sr-only">Dili Türkçe yap</span>
        </Link>
      )}
      {/* <p>Locale switcher:</p>
      <ul>
        {i18n.locales.map((locale) => {
          return (
            <li key={locale}>
              <Link href={redirectedPathname(locale)}>{locale}</Link>
            </li>
          )
        })}
      </ul> */}
    </div>
  )
}
